import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../store';
import { UserProfile } from '../../store/auth/user-profile';
import { AuthService } from '../../store/services/auth.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.sass']
})
export class ProfileComponent implements OnInit {
  private currentUser$: Observable<UserProfile>;

  constructor(
    private store: Store<fromRoot.State>,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
  ) {}

  ngOnInit() {
    this.currentUser$ = this.store.select(state => state.auth.profile);
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/pages/profile/profile.component.ts